import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { LenguageTabla } from "../../Comunes/LenguajeTabla/LenguajeTabla";
import moment from "moment";
import $ from "jquery";
import { Notificar } from "../../Comunes/Notificador";
import ModificarCuotaAtrasadaModal from "./ModificarCuotaAtrasadaModal";

function OperacionesCambioCuotasAtrasadas({
  operaciones,
  actualizarOperaciones = null,
  permiteSeleccionar = false,
  permiteEditar = false,
  permiteEliminar = false,
  soloLectura = false,
}) {
  const tableRef = useRef();

  useEffect(() => {
    const botonesTabla = permiteSeleccionar ? ["selectAll", "selectNone"] : [];
    const posicionDom = permiteSeleccionar
      ? '<"mb-3"B><"float-left"l><"text-right"f>rt<"float-left"i><"text-right"p>'
      : '<"float-left"l><"text-right"f>rt<"float-left"i><"text-right"p>';

    operaciones.forEach((op) => {
      if (!op.tipoAccion) {
        op.tipoAccion = "M";
      }
    });

    const tabla = $(tableRef.current).DataTable({
      language: LenguageTabla,
      paging: !permiteEditar,
      pagingType: "full_numbers",
      processing: true,
      destroy: true,
      data: operaciones,
      select: permiteSeleccionar && {
        style: "multi",
        selector: "td:first-child",
      },
      dom: posicionDom,
      buttons: botonesTabla,
      columns: [
        {
          title: "Selecionar",
          data: null,
          defaultContent: "",
          className: "select-checkbox",
          searchable: false,
          orderable: false,
          visible: permiteSeleccionar,
        },
        {
          title: "Operación",
          data: "operacion",
        },
        {
          title: "Periodo",
          data: "fechaPeriodo",
          render: function (row) {
            return row !== null ? moment(row).format("DD/MM/YYYY") : "";
          },
        },
        {
          title: "Número de Cuota",
          data: "numeroCuotaAtrasada",
        },
        {
          title: "Tipo de Cuota",
          data: "tipoCuota",
        },
        {
          title: "Días de Atraso Reportados",
          data: "diasAtrasoReportado",
        },
        {
          title: "Días de Atraso Propuesto",
          data: null,
          createdCell: function (cell, cellData, rowData, rowIndex, colIndex) {
            function actualizarDiasAtraso(operacion) {
              tabla.row(rowIndex).data(operacion).draw(false);
              actualizarOperaciones(tabla.rows().data().toArray());
            }

            ReactDOM.render(
              <div className="d-flex justify-content-between">
                {rowData.tipoAccion === "E" && !soloLectura ? (
                  <h6>
                    <span className="badge badge-secondary">Eliminar</span>
                  </h6>
                ) : rowData.diasAtrasoPropuesto === null ? (
                  <small className="text-muted">{soloLectura ? "" : "Sin asignar"}</small>
                ) : (
                  rowData.diasAtrasoPropuesto
                )}

                {permiteEditar ? (
                  <div className="mr-4">
                    <ModificarCuotaAtrasadaModal
                      cuotaAtrasada={cellData}
                      actualizarDiasAtraso={actualizarDiasAtraso}
                    />

                    <button
                      className="btn btn-outline-danger btn-xs js-eliminar-cuota ml-2"
                      title="Eliminar Días de Atraso"
                    >
                      <i className="fas fa-times-circle"></i>
                    </button>
                  </div>
                ) : null}
              </div>,
              cell
            );
          },
          searchable: false,
          orderable: false,
          visible: permiteEditar || soloLectura,
        },
        {
          title: "Acciones",
          data: "nombreTipoAccion",
          searchable: false,
          orderable: false,
          visible: soloLectura,
        },
        {
          title: "Excluir de Solicitud",
          data: null,
          defaultContent:
            "<center><button class='btn btn-danger btn-sm js-eliminar' title='Eliminar Registro'><i class='fa fa-trash'></i></button></center>",
          searchable: false,
          orderable: false,
          visible: permiteEliminar,
        },
      ],
    });

    tabla.off("click");

    tabla.on("select deselect", function (e) {
      actualizarOperaciones(tabla.rows({ selected: true }).data().toArray());
    });

    tabla.on("click", ".js-eliminar", function () {
      if (tabla.rows().data().count() === 1) {
        Notificar(
          "error",
          "No se puede eliminar. La solicitud debe tener al menos una operación."
        );
        return;
      }

      tabla.row($(this).parents("tr")).remove().draw(false);
      actualizarOperaciones(tabla.rows().data().toArray());
    });

    tabla.on("click", ".js-eliminar-cuota", function () {
      const tr = $(this).closest("tr");
      let rowData = tabla.row(tr).data();
      rowData.tipoAccion = "E";
      rowData.diasAtrasoPropuesto = null;

      tabla.row(tr).data(rowData).draw(false);
      actualizarOperaciones(tabla.rows().data().toArray());
    });
  }, [
    operaciones,
    actualizarOperaciones,
    permiteSeleccionar,
    permiteEditar,
    permiteEliminar,
    soloLectura,
  ]);

  return (
    <div className="card shadow mb-4">
      <div className="card-header">
        <h6 className="m-0 font-weight-bold text-primary">Operaciones</h6>
      </div>
      <div className="card-body">
        <table
          className="table table-striped table-hover w-auto display"
          ref={tableRef}
        />
      </div>
    </div>
  );
}

export default OperacionesCambioCuotasAtrasadas;
